// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu6 = () => {
    const { menuDashboard6 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard6?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard6.id,
        title: <FormattedMessage id={`${menuDashboard6.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard6.icon],
        type: menuDashboard6.type,
        children: ChildrenList
    };

    return dashboardList;
};
